module.exports = __webpack_public_path__ + "img/scroll_06_te.04c469da.png";